import { useState, useRef, FormEvent } from "react";

interface WaitlistFormProps {
  variant?: "default" | "final";
}

export function WaitlistForm({ variant = "default" }: WaitlistFormProps) {
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setEmail("");

    setTimeout(() => {
      setSubmitted(false);
      if (inputRef.current) {
        inputRef.current.placeholder = variant === "final" ? "your@email.com" : "founder@yourcompany.com";
      }
    }, 4000);
  };

  return (
    <form className="waitlist-form" onSubmit={handleSubmit}>
      <input
        ref={inputRef}
        type="email"
        placeholder={submitted ? "See you soon, partner." : (variant === "final" ? "your@email.com" : "founder@yourcompany.com")}
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        type="submit"
        style={submitted ? { background: "var(--green)" } : undefined}
      >
        {submitted ? "\u2713 You're in" : (variant === "final" ? "Reserve my spot \u2192" : "Join waitlist \u2192")}
      </button>
    </form>
  );
}
